import { historyCreationFunction } from "../settings";

export default historyCreationFunction();



// WEBPACK FOOTER //
// ./src/utils/history.ts